import React, { useContext } from 'react'
import firebase from 'firebase'
import { UserContext } from '../App'
import Links from './Links/Links'
import AddLink from './Links/AddLink'
function AdminView() {
    let db = firebase.database()
    const user = useContext(UserContext)
    return (
        <>
            <h3>{user !== null ? user.displayName : "Admin"}'s ShowCase</h3>
            <div className='row col-xl-6 col-xs-12 col-sm-9 col-md-6 mb-3 ml-1 d-flex justify-content-between space-between '>
                <div className='m-1'><AddLink /></div>
                <button className='btn btn-secondary text-primary m-1'>Appearance</button>
                <button className='btn btn-secondary text-primary m-1'>Settings</button>
            </div>
            <Links user={user.uid} />
        </>
    )
}
export default AdminView
